// extracted by mini-css-extract-plugin
module.exports = {"vertical":"_1IQSpB","horizontal":"_1l2PcK"};